export default __webpack_public_path__ + "static/28degrees-rewards-carousel-f3347508d7673925c888be9c1e3d3a3b.svg";